<script lang="ts">
  import { Accordion as AccordionPrimitive } from 'bits-ui-v2'
  import { cn } from '$lib/cn'

  let {
    ref = $bindable(null),
    class: className,
    ...restProps
  }: AccordionPrimitive.ItemProps = $props()
</script>

<AccordionPrimitive.Item
  bind:ref
  data-slot="accordion-item"
  class={cn('border-b border-b-[#272D37]', className)}
  {...restProps}
/>
